import moment from 'moment-timezone';
import { EASTERN_TIME_ZONE, INTEGRATORS_TIMESTAMP_FORMAT } from '../../../constants';

export const timestampIntegrators = (time) =>
  time ? moment(time).tz(EASTERN_TIME_ZONE).format(INTEGRATORS_TIMESTAMP_FORMAT) : null;
